import AI from "../assets/images/ai.jpg";
import ICON from "../assets/images/icon.ico";
import EForm from "../assets/images/E-Form.ico";
import ServiceDesk from "../assets/images/ServiceDesk.png";

const fixedData = [
    { icon: AI, value: "AI", url: "https://aithaihome.com/" },
    { icon: ICON, value: "ICON", url: "https://icon.homeip.net/" },
    { icon: EForm, value: "E-FORM", url: "https://e-form.homeip.net/" },
    { icon: ServiceDesk, value: "ServiceDesk", url: "http://1.179.178.90:8086/" }
];

export default fixedData;